import React from 'react'
import video from "../assets/images/derace-race-video.mp4"
import "../styles/main.css"
const Main = () => {
    return (
        // <div className="Main">
        <div className="css-13uvmm4">
            <video loop muted autoplay="autoplay" height="100%">
                <source src="https://d19z9f49qtk8r2.cloudfront.net/assets/video/derace-race-video.mp4" type="video/mp4" />
            </video>
            <div className="css-11qwv2g">
                <div className="container css-6q80oi">
                    <div className="css-1hp1o3p">
                        <div className="columns align-items-center css-13eakzl">
                            <div className="column is-half-desktop is-two-fifths-widescreen has-text-centered-mobile css-w5d8vv">
                                <h4 className="text-uppercase text-danger font-weight-semibold mb-3 intro">Introducing</h4>
                                <div className="css-1ktj4lg">Daytona</div>
                                <p className="pb-3">Daytona Racing Car Club is a play-to-earn NFT horse racing<br/> metaverse where you can participate in horse<br/> races,
                                    breed NFT horses with unique<br/> characteristics,
                                    build your own NFT hippodrome<br/> and make profit while doing it.
                                </p>
                                <a className="button btn-rounded" href="/races">Race</a>
                                <a href="https://exchange.derace.com" target="_blank" className="button is-outlined is-inverted is-rounded" rel="noreferrer">Ticket Redeem</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        // </div>
    )
}

export default Main
 // style={{position : 'absolute'}}